const RedirectingToNewPath = ({ newPath = '' }) => {
  if (!newPath) {
    throw new Error('Path should be defined');
  }

  return (
    <h3 className="text-center padding">
      {translate('Redirecting to {{ newPath }}...', {
        newPath,
      })}
    </h3>
  );
};

// eslint-disable-next-line import/no-default-export
export default RedirectingToNewPath;
